import React from "react";

import { Paper } from "@/components/paper/Paper";
import { LocalLadyIdContextProvider } from "@/context/local-lady-id-context/LocalLadyId.context";
import { SignInForm } from "@/features/forms/sign-in-form/SignInForm";

import { ModalCloseCross } from "../components/ModalCloseCross";
import { CommonModalProps } from "../models";

type PropTypes = {
  localLadyId?: string;
};

export const SignInFormModal: React.FC<CommonModalProps & PropTypes> = ({
  onClose,
  localLadyId,
}) => {
  return (
    <LocalLadyIdContextProvider ladyId={localLadyId}>
      <Paper
        data-testid="signInModal"
        className="p-4 py-8 md:p-8 w-[400px] max-w-full min-h-min relative"
      >
        <ModalCloseCross absolute onClose={onClose} />
        <SignInForm modalVersion />
      </Paper>
    </LocalLadyIdContextProvider>
  );
};
